function object(value) {
  return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
}

function text(value) {
  return String(value ?? '').trim();
}

function candidatePayload(action = {}) {
  const payload = object(action.payload);
  return object(payload.candidate);
}

function candidateDetails(candidate) {
  const title = text(candidate.title || candidate.label);
  const sourceKind = text(candidate.sourceKind || candidate.source_kind || candidate.source);
  const sourceRef = text(candidate.sourceRef || candidate.source_ref);
  const content = text(candidate.content || candidate.summary || title);
  return { title, sourceKind, sourceRef, content };
}

function candidateMarkdown(candidate = {}) {
  const explicit = text(candidate.markdown);
  if (explicit) {
    return explicit;
  }
  const { title, sourceKind, sourceRef, content } = candidateDetails(candidate);
  if (!title || !sourceKind) {
    return '';
  }
  return [
    `## 已添加结构节点：${title}`,
    `来源：${sourceKind}${sourceRef ? ` / ${sourceRef}` : ''}`,
    '',
    content,
  ].join('\n');
}

export function buildArtifactNodeInsertDraft({
  action = {},
  currentContent = '',
} = {}) {
  const candidate = candidatePayload(action);
  const patchMarkdown = candidateMarkdown(candidate);
  const content = text(currentContent);
  if (!patchMarkdown) {
    return content;
  }
  if (content.includes(patchMarkdown)) {
    return content;
  }
  return [content, patchMarkdown].filter(Boolean).join('\n\n');
}

export default buildArtifactNodeInsertDraft;
